import {PropertyPayloadModifierInterface} from '../property-payload-modifier-interface';

export class DeletePropertyPayloadModifier implements PropertyPayloadModifierInterface {

    public modify(property: string, entity: any) {
        delete entity[property];
    }
}
